module.exports = __webpack_public_path__ + "media/images/icons/webhook-b90009ed90f1e43f7c738377a9f5c6fc.svg";